<template>
  <Catalogs
    title="Статусы заявок на подбор"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'RecruitTaskStatusAdd'"
    :route-edit="'RecruitTaskStatusEdit'"
    :route-view="'RecruitTaskStatusView'"
    :route-path="'/recruit_task_statuses'"
    :can-edit="canEditRecruitTaskStatus()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "RecruitTaskStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'recruit-task-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'recruit-task-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getRecruitTaskStatuses(data);
    },
    canEditRecruitTaskStatus() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_TASK_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.recruit-task-status-id {
  width: 60px;
  text-align: center;
}

.recruit-task-status-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitTaskStatuses/RecruitTaskStatuses.vue